import { Injectable } from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {Embed} from 'embed';
import {take} from 'rxjs/operators';
import {from} from 'rxjs';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root'
})
export class SavePowerBiReportCommandHandler implements IPlatformCommandHandler {

  constructor(private snackBarService: SnackBarService) { }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const report = handler.metaData['PbiEmbedReport'] as Embed;
    const isDirty = handler.metaData['reportDirty'];
    if (report) {
      if (isDirty) {
        from(report.save()).subscribe(res => {
          this.snackBarService.showInformation('Your Power bi report saved successfully.');
        }, error => {
          this.snackBarService.showError('Your Power bi report can not be saved at this moment.');
        });
      } else {
        this.snackBarService.showInformation('Nothing to save.');
      }
    }
    return true;
  }
}
